<template>
  <div class="relative">
    <div class="gap-6 block sm:grid sm:grid-cols-2">
      <ArticleListItem
        v-for="(article, index) in articles"
        class="rounded-12"
        :class="{ hidden: isCollapsed && index > 7 }"
        :key="`content-${index}`"
        :article="article"
      />
    </div>
    <a
      v-if="optionalCta?.link"
      class="pt-4 font-semibold underline text-gray-500 block text-center col-span-2"
      :class="{ hidden: isCollapsed }"
      :href="optionalCta?.link"
    >
      {{ optionalCta.label }}
    </a>
    <template v-if="articles.length > 5">
      <div class="absolute left-0 right-0 bottom-0" :class="{ hidden: !isCollapsed }">
        <div
          class="block w-full h-60 sm:h-24 bg-gradient-to-t from-white to-transparent sm:via-white"
          role="none"
        />
        <button
          @click="isCollapsed = false"
          class="block mx-auto py-2 text-16 link col-span-2 z-10 bg-white w-full"
          :class="{ hidden: !isCollapsed }"
        >
          {{ $t('read_more') }}
        </button>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import ArticleListItem from './article-list-item.vue'
import type { GQLRelatedContentSlice } from './generated/related-content'

defineProps<{
  optionalCta: GQLRelatedContentSlice['optionalCta']
  articles: GQLRelatedContentSlice['articleLinks']
}>()

const isCollapsed = ref(true)
</script>
